module.exports = __webpack_public_path__ + "img/group-img-presentation.11ba9254.jpg";